import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

//   public exportAsExcelFile(json: any[], excelFileName: string): void {
//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
//     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     this.saveAsExcelFile(excelBuffer, excelFileName);
//   }

//   private saveAsExcelFile(buffer: any, fileName: string): void {
//     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
//     FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
//   }

data: any[] = [
    { id: 1, name: 'Alice', age: 24 },
    { id: 2, name: 'Bob', age: 22 }
  ];

  exportToExcel(excelData, sheetName, fileName): void {
    // Create a new worksheet from the data
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // Create a new workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Generate a buffer
    const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob from the data
    const blob: Blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(blob, fileName + '.xlsx');
  }
}
